// One type system for the web player and the portal (Sol round6, 2026-10-06; owner: "we need to use consistent [fonts],
// especially when font and sizing difference is huge").
//
// Sizes: only the steps below, never smaller than 12px. Normal reading text is TYPE.base (16).
// Families: on web, Poppins for headings and Plus Jakarta Sans for everything else (body, controls, labels), served from
// this app (public/fonts) with system fallbacks. Native keeps its own platform fonts until they are tested separately,
// so on iOS/Android the families resolve to undefined and React Native uses the system font as before.
import { Platform } from 'react-native';

export const TYPE = {
  xs: 12,
  sm: 14,
  base: 16,
  lg: 18,
  xl: 20,
  '2xl': 24,
  '3xl': 30,
  '4xl': 36,
  '5xl': 48,
};

export const MIN_FONT_SIZE = TYPE.xs;

const IS_WEB = Platform.OS === 'web';

export const FONTS = {
  heading: IS_WEB ? '"Poppins", "Plus Jakarta Sans", system-ui, -apple-system, "Segoe UI", sans-serif' : undefined,
  body: IS_WEB ? '"Plus Jakarta Sans", system-ui, -apple-system, "Segoe UI", sans-serif' : undefined,
};
